export const AgencesVitrine: string[] = [
	"Agence indépendante",
	"123webimmo",
	"4% Immobilier",
	"AB Immobilier",
	"Abithea",
	"Abrinor Debeunne",
	"Action Immo",
	"Agence Centrale",
	"Agence comtesse",
	"Agence de la Gare",
	"Agence du sud",
	"Agence française de l'immobilier",
	"Agence gare",
	"Agence Principale",
	"Agences DAURE Immobilier",
	"Agences Privées",
	"AJP Immobilier",
	"Alpha Immo",
	"AMP Loire",
	"Apostrophes Immobilier",
	"Arthurimmo",
	"Atlas immobilier",
	"Atrium Gestion",
	"Blot",
	"Brosset Immobilier",
	"Century 21",
	"Cimm immobilier",
	"Citya Immobilier",
	"Clairimmo",
	"CM-CIC Immobilier",
	"Cofim Conseil financier immobilier",
	"Coldwell Banker",
	"Côté Acheteur",
	"Côté Particuliers",
	"Danielfeau",
	"Daunay Immobilier",
	"Demeures d'Occitanie",
	"DM Durand-Montouché Immobiliero",
	"Elyse avenue",
	"ERA Immobilier",
	"Eric Gal Immobilier",
	"Eric Mey",
	"Foncia",
	"Foncière Lelièvre",
	"Giboire",
	"Groupimmo Alsace",
	"Guy Hoquet",
	"Hectare",
	"Human Immobilier",
	"ICF Habitat",
	"Imaj Immobilier",
	"IMM-OUEST Bretagne",
	"Immo 5",
	"Immo Ouest",
	"Immobilier de France",
	"Immobilière Bartholdi",
	"Immocial",
	"ImmoCorse",
	"ImmoSky",
	"Keller Williams",
	"L'Adresse",
	"L'agence des arcades",
	"La résidence",
	"Laforêt",
	"Lamy Immobilier",
	"Le Tuc Immo",
	"Les agences Espace Immobilier",
	"Les agents de l'immobilier",
	"Liberkeys",
	"Logéhome",
	"Lux résidence",
	"Maisons LCA",
	"MarketPlace Immobilier",
	"Native Immobilier",
	"Nestenn",
	"Nexity Immobilier",
	"Noblimo",
	"Orpi",
	"Parki Immobilier",
	"Pichet Immobilier",
	"Power Immobilier",
	"Primo Immobilier",
	"Proximmo",
	"Reborn Immobilier",
	"Remax",
	"Réseau MDI",
	"Sigla Immobilier",
	"Sotheby's",
	"Square Habitat",
	"Stéphane Plaza Immobilier",
	"Swixim",
	"Terres & demeures",
	"Topimmo",
	"Transaxia",
	"We Invest"
]
